export default "__VITE_ASSET__5g_aaSID__"